module.exports = __webpack_public_path__ + "static/media/car-battery.365d0455.svg";